export default {"src":"/_next/static/media/image_logo_full.b67d65e9.svg","height":67,"width":373,"blurWidth":0,"blurHeight":0};